import type { Action, StoreActionApi } from 'react-sweet-state';
import type { ImportType } from '../../../../common/constants/import-type';
import type { Step } from '../../../../common/constants/steps';
import type { State } from '../../../../common/types';

type setImportTypeAndStepArgs = {
	importType: ImportType;
	step: Step;
};

export type SetImportTypeAndStepAction = ({
	importType,
	step,
}: setImportTypeAndStepArgs) => Action<State, void, void>;
export const setImportTypeAndStep =
	({ importType, step }: setImportTypeAndStepArgs) =>
	({ setState }: StoreActionApi<State>) => {
		setState({ importType, step });
	};
